export function getTeamsMember(state) {
  return state.teams_members;
}

export function getTeamMemberById(state, teamsMemberId) {
  return getTeamsMember(state).get(teamsMemberId);
}